import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  Input,
  Host,
  Optional
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ValidationErrors
} from '@angular/forms';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextFieldComponent),
  multi: true
};

@Component({
  selector: 'text-field',
  inputs: [...AbstractField.inputs, 'type', 'maxLength', 'minLength', 'name'],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="name || autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        [type]="type"
        [email]="type === 'email'"
        [attr.maxLength]="maxLength ? maxLength : null"
        [attr.minLength]="minLength ? minLength : null"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class TextFieldComponent extends AbstractField {
  type = 'text';
  maxLength = 0;
  minLength = 0;
  name = '';
  constructor() {
    super();
  }
}
